/* Registers the PWA service worker and shows a gentle "Update available" banner
 * when a new deploy is detected — the user chooses when to refresh, so an
 * in-progress session is never interrupted. No-op in development. */

export function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((reg) => {
        // A worker is already waiting (update downloaded in a previous visit).
        if (reg.waiting && navigator.serviceWorker.controller) {
          showUpdateBanner(reg.waiting);
        }
        reg.addEventListener('updatefound', () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            // "installed" + an existing controller == this is an UPDATE,
            // not the very first install. Prompt to refresh.
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              showUpdateBanner(installing);
            }
          });
        });
      })
      .catch(() => {});

    // When the new worker takes control after the user accepts, reload once.
    let reloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  });
}

function showUpdateBanner(worker) {
  if (document.getElementById('pvbi-update-banner')) return;

  const bar = document.createElement('div');
  bar.id = 'pvbi-update-banner';
  bar.setAttribute('role', 'status');
  bar.style.cssText = [
    'position:fixed', 'left:50%', 'transform:translateX(-50%)', 'bottom:20px',
    'z-index:2147483647', 'display:flex', 'align-items:center', 'gap:14px',
    'padding:12px 18px', 'border-radius:12px', 'background:#161b22',
    'color:#e6edf3', 'border:1px solid #c47a10',
    'box-shadow:0 8px 28px rgba(0,0,0,.45)',
    'font:500 14px/1.2 system-ui,-apple-system,Segoe UI,Roboto,sans-serif',
    'max-width:calc(100vw - 32px)',
  ].join(';');

  const text = document.createElement('span');
  text.textContent = 'A new version is available.';

  const btn = document.createElement('button');
  btn.textContent = 'Refresh';
  btn.style.cssText = [
    'cursor:pointer', 'border:0', 'border-radius:8px', 'padding:8px 16px',
    'background:#c47a10', 'color:#0d1117', 'font:600 14px system-ui,sans-serif',
  ].join(';');
  btn.onclick = () => {
    btn.disabled = true;
    btn.textContent = 'Updating…';
    worker.postMessage('SKIP_WAITING');
  };

  const dismiss = document.createElement('button');
  dismiss.setAttribute('aria-label', 'Dismiss');
  dismiss.textContent = '✕';
  dismiss.style.cssText = 'cursor:pointer;border:0;background:transparent;color:#8b949e;font-size:16px;padding:4px';
  dismiss.onclick = () => bar.remove();

  bar.append(text, btn, dismiss);
  document.body.appendChild(bar);
}
